<template>
	<div class="wrapper">
		<div class="animated fadeIn">
			<b-card header="Version Configurator">
				<div class="table-responsive">
					<table class="table table-hover table-striped table-bordered table-small table-fixed">
						<thead>
						<tr>
							<th v-for="header in headers" :key="header.key" class="text-center">
								{{ header.label }}
							</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="config in configuration" :key="config.code">
							<th class="text-right">{{ config.code }}</th>
							<th>{{ config.name }}</th>
							<td v-for="version in versions" :key="config.code + '_' + version.id" class="text-center">
								<b-form-checkbox
									:id="config.code + '_' + version.id"
									v-model="config[version.id]"
									:name="config.code + '_' + version.id"
									value="1"
									unchecked-value="0"
								>
								</b-form-checkbox>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
				<footer slot="footer">
					<b-button v-if="$store.getters.canWrite" variant="primary" class="float-right" size="lg" @click="saveConfiguration"><i
						class="fa fa-save"></i> Save
					</b-button>
					<b-button variant="warning" size="lg" @click="refreshConfigurationTable"><i class="fa fa-refresh"></i> Reset
					</b-button>
				</footer>
			</b-card>
		</div>
	</div>
</template>

<script>
	import moduleService from '@/services/moduleService'
	import versionService from '@/services/versionService'
	import toastService from "@/services/toastService";

	export default {
		name: "VersionConfigurator",
		data: () => ({
			modules: [],
			versions: [],
			headers: [
				{key: 'code', label: 'Code'},
				{key: 'module', label: 'Module'},
			],
			configuration: [],
		}),
		methods: {
			refreshConfigurationTable() {
				versionService.getVersionList((data) => {
					this.versions = data;

					let headers = [
						{key: 'code', label: 'Code'},
						{key: 'module', label: 'Module'},
					];

					this.versions.forEach((version) => {
						headers.push({
							key: version.id,
							label: version.name,
						})
					});

					this.headers = headers;

					moduleService.getModuleList((data) => {
						this.modules = data;

						let options = [];
						this.modules.forEach((module) => {
							let option = {
								id: module.id,
								code: module.code,
								name: module.name
							};

							this.versions.forEach((version) => {
								option[version.id] = version.modules.find((m) => m.code === module.code) === undefined ? "0" : "1"
							});

							options.push(option);

							this.configuration = options;
						});
					});
				});
			},
			saveConfiguration() {
				let table = [];

				this.configuration.forEach((option) => {
					this.versions.forEach((version) => {
						if (option[version.id] === "1") {
							table.push({
								moduleId: option.id,
								versionId: version.id
							})
						}
					});
				});

				versionService.saveConfiguration({
					table: table
				}, () => {
					toastService.showSuccessToast("Configuration Updated");
					this.refreshConfigurationTable();
				}, () => {
					toastService.showErrorToast("Failed to update Configuration");
				})
			}
		},

		mounted() {
			this.refreshConfigurationTable();
		}
	}
</script>

<style scoped>

</style>
